"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.sha256 = exports.base64 = exports.hex = exports.md5 = void 0;
const cuid2_1 = require("@paralleldrive/cuid2");
const md5_1 = __importDefault(require("crypto-js/md5"));
function md5(text = (0, cuid2_1.createId)()) {
    return (0, md5_1.default)(text).toString();
}
exports.md5 = md5;
function hex(bytes) {
    return [...new Uint8Array(bytes)]
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
}
exports.hex = hex;
exports.base64 = {
    encode: (text) => btoa(String.fromCodePoint(...new TextEncoder().encode(text))),
    decode: (encoded) => new TextDecoder().decode(Uint8Array.from(atob(encoded), (c) => c.codePointAt(0))),
};
function sha256Buffer(text) {
    return __awaiter(this, void 0, void 0, function* () {
        const encoder = new TextEncoder();
        const data = encoder.encode(text);
        return crypto.subtle.digest('SHA-256', data);
    });
}
function sha256(text = (0, cuid2_1.createId)()) {
    return __awaiter(this, void 0, void 0, function* () {
        return hex(yield sha256Buffer(text));
    });
}
exports.sha256 = sha256;
function encrypt(text, key) {
    return __awaiter(this, void 0, void 0, function* () {
        const cipherKey = yield crypto.subtle.importKey('raw', yield sha256Buffer(key), 'AES-CBC', false, ['encrypt']);
        const iv = crypto.getRandomValues(new Uint8Array(16));
        const encryptedBuffer = yield crypto.subtle.encrypt({ name: 'AES-CBC', iv }, cipherKey, new TextEncoder().encode(text));
        const ivBase64 = btoa(String.fromCodePoint(...iv));
        const encryptedBase64 = btoa(String.fromCodePoint(...new Uint8Array(encryptedBuffer)));
        return `${ivBase64}:${encryptedBase64}`.replace(/[=]/gu, '');
    });
}
exports.encrypt = encrypt;
function decrypt(text, key) {
    return __awaiter(this, void 0, void 0, function* () {
        const [iv, data] = text
            .split(':')
            .map((s) => new Uint8Array([...atob(s)].map((c) => c.codePointAt(0))));
        const cipherKey = yield crypto.subtle.importKey('raw', yield sha256Buffer(key), 'AES-CBC', false, ['decrypt']);
        const decryptedBuffer = yield crypto.subtle.decrypt({ name: 'AES-CBC', iv }, cipherKey, data);
        return new TextDecoder().decode(decryptedBuffer);
    });
}
exports.decrypt = decrypt;
